// components/ProgressBar.jsx
import React from "react";

const ProgressBar = ({ label, value, max = 10, color }) => {
  const percent = Math.min((value / max) * 100, 100);

  return (
    <div style={{ marginBottom: 18, textAlign: "right" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "160px 1fr 50px",
          alignItems: "center",
          gap: 16
        }}
      >
        {/* Label */}
        <div
          style={{
            fontSize: 16,
            lineHeight: "18px",
            color: "#222"
          }}
        >
          {label}
        </div>

        {/* Bar */}
        <div
          style={{
            width: "100%",
            height: 18,
            background: "#dfe6e3",
            borderRadius: 12,
            overflow: "hidden"
          }}
        >
          <div
            style={{
              width: `${percent}%`,
              height: "100%",
              background: color,
              borderRadius: 12,
              transition: "width 0.3s ease"
            }}
          />
        </div>

        {/* Value */}
        <div
          style={{
            fontSize: 18,
            fontWeight: 500,
            textAlign: "right",
            color: "#222"
          }}
        >
          {value}/{max}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
